import styled, { css } from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { DocumentFillingStatus } from '@/models/documents.model';
import { Button } from '@/ui';

export const StyledWrapper = styled.div<{ $status: DocumentFillingStatus }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 1.25rem;
  gap: 0.5rem;
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  background-color: ${pickThemeColor('WHITE')};
  border-radius: 0.35rem;

  ${({ $status }) => {
    switch ($status) {
      case DocumentFillingStatus.EXPIRED:
        return css`
          color: ${pickThemeColor('DEEP_CRIMSON')};
          background: ${pickThemeColor('DEEP_CRIMSON_PALE')};
          border: 1px solid ${pickThemeColor('DEEP_CRIMSON')};
        `;
      case DocumentFillingStatus.FILLED:
        return css`
          color: ${pickThemeColor('DARK_GREEN')};
          background: ${pickThemeColor('DARK_GREEN_PALE')};
          border: 1px solid ${pickThemeColor('DARK_GREEN')};
        `;
      case DocumentFillingStatus.UNFILLED:
      default:
        return css`
          color: ${pickThemeColor('BLACK_PRIMARY')};
          background: ${pickThemeColor('WHITE')};
          border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
        `;
    }
  }}

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
  }
`;

export const StyledCardTitle = styled.div`
  color: inherit;
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};
  }
`;

export const StyledCardDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;

  span {
    color: ${pickThemeColor('BLACK_PRIMARY')};
    ${pickThemeFontStyles('14', '20')};
  }
`;

export const StyledButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    width: initial;
  }
`;

export const StyledButton = styled(Button)`
  .anticon {
    svg {
      fill: none;
    }
  }
`;
